// The API returns some text fields (e.g. product names) HTML-encoded, so a
// literal ampersand arrives as "&amp;". React renders string children
// verbatim — it does NOT decode entities — so without this they show as
// "&amp;" on screen. A <textarea>'s content is RCDATA: the browser decodes
// character references but never parses tags, so this is a safe decode with
// no HTML-injection risk.
export const decodeHtmlEntities = (value?: string | null): string => {
  if (!value) return ''
  if (value.indexOf('&') === -1) return value
  const el = document.createElement('textarea')
  el.innerHTML = value
  return el.value
}
